// extracted by mini-css-extract-plugin
export default {"container":"FalseInputNumber_container__wSpqQ","label":"FalseInputNumber_label__FE1o1","input":"FalseInputNumber_input__WRH1O"};